import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.34 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.75 5.73H8.17c-.17 0-.3.13-.3.3s.13.3.3.3h2.59c.17 0 .3-.13.3-.3s-.14-.3-.31-.3m0 2.26H8.17c-.17 0-.3.13-.3.3s.13.3.3.3h2.59c.17 0 .3-.13.3-.3s-.14-.3-.31-.3m0 2.26H8.17c-.17 0-.3.13-.3.3s.13.3.3.3h2.59c.17 0 .3-.13.3-.3s-.14-.3-.31-.3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.04 15.26h-.89c0-.01.01-.01.01-.02V1.67c0-.1-.05-.19-.13-.25a.28.28 0 0 0-.28-.03L5.96 3.97c-.12.04-.19.16-.19.28v2.93H2.83c-.17 0-.3.13-.3.3v1.6c0 .17.13.3.3.3s.3-.13.3-.3v-1.3h2.63v7.46c0 .01.01.01.01.02H3.91c-.17 0-.3.13-.3.3s.13.3.3.3h10.12c.17 0 .3-.13.3-.3s-.13-.3-.29-.3m-7.68-.02V4.46l6.19-2.36v13.14c0 .01.01.01.01.02h-6.2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.31 13.01c0-1.05-.63-2.98-1.65-2.98-1.03 0-1.66 1.93-1.66 2.98 0 1.16.68 1.74 1.41 1.84-.02.05-.06.09-.06.15v.56c0 .17.13.3.3.3s.3-.13.3-.3V15c0-.06-.03-.1-.06-.14.74-.11 1.42-.69 1.42-1.85m-2.71 0c0-1.02.6-2.38 1.05-2.38s1.05 1.36 1.05 2.38c0 .78-.4 1.27-1.05 1.27s-1.05-.49-1.05-1.27"
    }, null, -1)
  ])))
}
export default { render: render }